import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxDataGridModule, DxSelectBoxModule, DxTreeListModule, DxButtonModule, DxLoadPanelModule, DxPopupModule } from 'devextreme-angular';
import { NgSelectModule, NG_SELECT_DEFAULT_CONFIG } from '@ng-select/ng-select';

import { MasterMappingsRoutingModule } from './master-mappings-routing.module';
import { MasterMappingsEditComponent } from './master-mappings-edit/master-mappings-edit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MasterMappingsBrowseComponent } from './master-mappings-browse/master-mappings-browse.component';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MasterMappingsRoutingModule,
    NgSelectModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxTreeListModule,
    DxButtonModule,
    DxPopupModule,
    DxLoadPanelModule
  ],
  declarations: [MasterMappingsEditComponent, MasterMappingsBrowseComponent]
})
export class MasterMappingsModule { }
